module.exports = __webpack_public_path__ + "static/media/LeftMuted.9380a1c4.svg";